// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__eLajw","colMaxWidth":"Table_colMaxWidth__3BVSH"};